export default "__VITE_ASSET__c1G3ZZy7__"